import { render, staticRenderFns } from "./Cumples.vue?vue&type=template&id=3fac5952&"
import script from "./Cumples.vue?vue&type=script&lang=js&"
export * from "./Cumples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports